module.exports = __webpack_public_path__ + "static/FrankensteinPromo-24-2a4628240d227e743e87c4edf26774fd.jpg";